import React from "react";

export default function Layout({ children, className }) {
  return (
    <div className={`app-body-main row bg-white p-4 shadow-sm ${className}`}>
      <div className="col-12">
        {children}
      </div>
    </div>
  );
}
